// extracted by mini-css-extract-plugin
export default {"title":"Trailers_title__dwSST"};